










import store from '@/store';

export default
  props:
    # ラベル
    label:
      type: String
      default: ''
    isActive:
      type: Boolean
      default: false
    type:
      type: String
      default: 'submit'
    disabled:
      type: Boolean
      default: false

  # click: クリックイベント
  methods: {
    click: (e) ->
      @$emit('click')
  }
